export default function AuthPlugin({ $auth }) {
  function routeOption(route, key, value) {
    return route.matched.some((m) => {
      if (process.client) {
        return Object.values(m.components).some((component) => component.options && component.options[key] === value);
      }
      return Object.values(m.components).some(
        // eslint-disable-next-line no-underscore-dangle
        (component) => Object.values(component._Ctor).some((ctor) => ctor.options && ctor.options[key] === value),
      );
    });
  }
  $auth.onRedirect((redirectTo, redirectFrom) => {
    const externalRoutes = ['/customer/account/welcome'];
    if (externalRoutes.includes(redirectTo)) {
      window.location.href = redirectTo;
      return false;
    }
    if (!$auth.loggedIn) {
      const isAuthRequired = routeOption($auth.ctx.route, 'auth', true);
      if (!isAuthRequired) {
        return redirectFrom;
      }
    }
    return redirectTo;
  });
}
